<template>
    <div class="bulk-actions-bar">
        <div class="bulk-actions-container">
            <div class="selection-section">
                <div class="selection-info">
                    <div class="selection-badge">
                        <i class="material-icons">check_circle</i>
                        <span class="count">{{ selectedCount }}</span>
                    </div>
                    <span class="selection-text">{{ $t("auto.selected") }}</span>
                </div>
                <div class="selection-controls">
                    <button class="control-btn" @click="$emit('select-all')" :title="$t('auto.selectAll')">
                        <i class="material-icons">select_all</i>
                        <span>{{ $t("auto.selectAll") }}</span>
                    </button>
                    <button class="control-btn" @click="$emit('deselect-all')" :title="$t('auto.clearSelection')">
                        <i class="material-icons">clear</i>
                        <span>{{ $t("auto.clear") }}</span>
                    </button>
                </div>
            </div>

            <div class="actions-container">
                <a-tooltip :title="$t('auto.addTag')" placement="bottom">
                    <button class="action-btn" @click="onAction('add-tags')">
                        <i class="material-icons">label</i>
                        <span>{{ $t("auto.tag") }}</span>
                    </button>
                </a-tooltip>

                <a-tooltip :title="$t('auto.addDepartment')" placement="bottom">
                    <button class="action-btn" @click="onAction('add-preferred-department')">
                        <i class="material-icons">apartment</i>
                        <span>{{ $t("auto.department") }}</span>
                    </button>
                </a-tooltip>

                <a-tooltip :title="$t('auto.addUser')" placement="bottom">
                    <button class="action-btn" @click="onAction('add-preferred-agents')">
                        <i class="material-icons">person</i>
                        <span>{{ $t("auto.userwith") }}</span>
                    </button>
                </a-tooltip>

                <a-tooltip :title="$t('auto.giveOwnership')" placement="bottom">
                    <button class="action-btn" @click="onAction('set-owner')">
                        <i class="material-icons">assignment_ind</i>
                        <span>{{ $t("auto.owner") }}</span>
                    </button>
                </a-tooltip>

                <a-tooltip :title="$t('auto.addNote')" placement="bottom">
                    <button class="action-btn" @click="onAction('add-note')">
                        <i class="material-icons">note_add</i>
                        <span>{{ $t("auto.note") }}</span>
                    </button>
                </a-tooltip>

                <a-tooltip :title="$t('auto.updateProfileField')" placement="bottom">
                    <button class="action-btn" @click="onAction('add-contact-property')">
                        <i class="material-icons">badge</i>
                        <span>{{ $t("auto.profileField") }}</span>
                    </button>
                </a-tooltip>

                <a-tooltip :title="$t('auto.markAsAnswered')" placement="bottom">
                    <button class="action-btn" @click="onAction('mark-as-answered')">
                        <i class="material-icons">mark_email_read</i>
                        <span>{{ $t("auto.answered") }}</span>
                    </button>
                </a-tooltip>

                <a-tooltip :title="$t('auto.markAsRead')" placement="bottom">
                    <button class="action-btn" @click="onAction('mark-as-read')">
                        <i class="material-icons">done_all</i>
                        <span>{{ $t("auto.read") }}</span>
                    </button>
                </a-tooltip>

                <a-tooltip :title="$t('auto.vipStatus')" placement="bottom">
                    <button class="action-btn" @click="onAction('set-vip')">
                        <i class="material-icons">star</i>
                        <span>{{ $t("message.vipBadge") }}</span>
                    </button>
                </a-tooltip>
            </div>

            <button class="close-btn" @click="$emit('close')" :title="$t('auto.close')">
                <i class="material-icons">close</i>
            </button>
        </div>

        <BulkAddTagsModal
            :visible="bulkModal.visible && bulkModal.type === 'tags'"
            :selected-count="selectedCount"
            @confirm="onBulkModalConfirm"
            @cancel="onBulkModalCancel"
        />

        <BulkAddDepartmentModal
            :visible="bulkModal.visible && bulkModal.type === 'department'"
            :selected-count="selectedCount"
            @confirm="onBulkModalConfirm"
            @cancel="onBulkModalCancel"
        />

        <BulkAssignUserModal
            :visible="bulkModal.visible && bulkModal.type === 'user'"
            :selected-count="selectedCount"
            @confirm="onBulkModalConfirm"
            @cancel="onBulkModalCancel"
        />

        <BulkSetOwnerModal
            :visible="bulkModal.visible && bulkModal.type === 'owner'"
            :selected-count="selectedCount"
            :selected-contacts="selectedContacts"
            @confirm="onBulkModalConfirm"
            @cancel="onBulkModalCancel"
        />

        <BulkAddNoteModal
            :visible="bulkModal.visible && bulkModal.type === 'note'"
            :selected-count="selectedCount"
            @confirm="onBulkModalConfirm"
            @cancel="onBulkModalCancel"
        />

        <BulkSetPropertyModal
            :visible="bulkModal.visible && bulkModal.type === 'property'"
            :selected-count="selectedCount"
            @confirm="onBulkModalConfirm"
            @cancel="onBulkModalCancel"
        />

        <BulkSetVipModal
            :visible="bulkModal.visible && bulkModal.type === 'vip'"
            :selected-count="selectedCount"
            @confirm="onBulkModalConfirm"
            @cancel="onBulkModalCancel"
        />

        <BulkMarkAsAnsweredModal
            :visible="bulkModal.visible && bulkModal.type === 'answered'"
            :selected-count="selectedCount"
            @confirm="onBulkModalConfirm"
            @cancel="onBulkModalCancel"
        />

        <BulkMarkAsReadModal
            :visible="bulkModal.visible && bulkModal.type === 'read'"
            :selected-count="selectedCount"
            @confirm="onBulkModalConfirm"
            @cancel="onBulkModalCancel"
        />
    </div>
</template>

<script>
import BulkAddTagsModal from "./bulk-actions/BulkAddTagsModal.vue";
import BulkAddDepartmentModal from "./bulk-actions/BulkAddDepartmentModal.vue";
import BulkAssignUserModal from "./bulk-actions/BulkAssignUserModal.vue";
import BulkSetOwnerModal from "./bulk-actions/BulkSetOwnerModal.vue";
import BulkAddNoteModal from "./bulk-actions/BulkAddNoteModal.vue";
import BulkSetPropertyModal from "./bulk-actions/BulkSetPropertyModal.vue";
import BulkSetVipModal from "./bulk-actions/BulkSetVipModal.vue";
import BulkMarkAsAnsweredModal from "./bulk-actions/BulkMarkAsAnsweredModal.vue";
import BulkMarkAsReadModal from "./bulk-actions/BulkMarkAsReadModal.vue";
import { CONTACT_API } from "@/api/visitor";
import { sendSocketMessage } from "@/utils/socketStream";

export default {
    name: "BulkActionsBar",
    components: {
        BulkAddTagsModal,
        BulkAddDepartmentModal,
        BulkAssignUserModal,
        BulkSetOwnerModal,
        BulkAddNoteModal,
        BulkSetPropertyModal,
        BulkSetVipModal,
        BulkMarkAsAnsweredModal,
        BulkMarkAsReadModal,
    },
    props: {
        selectedCount: {
            type: Number,
            default: 0,
        },
        selectedContacts: {
            type: Array,
            default: () => [],
        },
    },
    data: function () {
        return {
            bulkModal: {
                visible: false,
                type: null,
            },
        };
    },
    methods: {
        onAction: function (action) {
            const actionModalMap = {
                "add-tags": "tags",
                "add-preferred-department": "department",
                "add-preferred-agents": "user",
                "set-owner": "owner",
                "add-note": "note",
                "add-contact-property": "property",
                "set-vip": "vip",
                "mark-as-answered": "answered",
                "mark-as-read": "read",
            };

            const modalType = actionModalMap[action];
            if (modalType) {
                this.bulkModal.type = modalType;
                this.bulkModal.visible = true;
            }
        },
        onBulkModalConfirm: async function (data) {
            this.bulkModal.visible = false;

            const visitorIds = this.selectedContacts.map((c) => c._id || c);
            const { action, payload } = data;

            try {
                this.$message.loading({ content: "İşlem yapılıyor...", key: "bulkAction", duration: 0 });

                const result = await CONTACT_API.bulkActionContacts(visitorIds, action, payload);

                this.$message.success({
                    content: result.message || "İşlem başarıyla tamamlandı",
                    key: "bulkAction",
                    duration: 2,
                });

                // Diğer temsilcilere socket mesajı gönder
                if (result.updatingFields && Object.keys(result.updatingFields).length > 0) {
                    sendSocketMessage("user visitor-bulk-operation", {
                        siteId: this.$store.state.site.site._id,
                        userId: this.$store.state.auth.user._id,
                        username: this.$store.state.auth.user.name,
                        visitorIds,
                        action,
                        payload,
                        updatingFields: result.updatingFields,
                    });
                }

                // Parent'a işlem tamamlandığını bildir
                this.$emit("bulk-action-complete");
            } catch (error) {
                this.$message.error({
                    content: error.message || "İşlem sırasında bir hata oluştu",
                    key: "bulkAction",
                    duration: 3,
                });
            }
        },
        onBulkModalCancel: function () {
            this.bulkModal.visible = false;
            this.bulkModal.type = null;
        },
    },
};
</script>

<style lang="scss" scoped>
.bulk-actions-bar {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);
    padding: 0;
    margin-bottom: 16px;
    animation: slideDown 0.3s ease-out;

    .bulk-actions-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px 16px;
        gap: 16px;
    }

    .selection-section {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-shrink: 0;

        .selection-info {
            display: flex;
            align-items: center;
            gap: 6px;

            .selection-badge {
                display: flex;
                align-items: center;
                gap: 5px;
                background: rgba(255, 255, 255, 0.2);
                padding: 4px 10px;
                border-radius: 16px;
                backdrop-filter: blur(10px);

                .material-icons {
                    font-size: 16px;
                    color: #fff;
                }

                .count {
                    font-size: 13px;
                    font-weight: 700;
                    color: #fff;
                }
            }

            .selection-text {
                font-size: 12px;
                font-weight: 500;
                color: rgba(255, 255, 255, 0.9);
            }
        }

        .selection-controls {
            display: flex;
            align-items: center;
            gap: 4px;

            .control-btn {
                display: flex;
                align-items: center;
                gap: 3px;
                padding: 4px 10px;
                background: rgba(255, 255, 255, 0.15);
                border: 1px solid rgba(255, 255, 255, 0.2);
                border-radius: 6px;
                color: #fff;
                font-size: 11px;
                font-weight: 500;
                cursor: pointer;
                transition: all 0.2s ease;

                .material-icons {
                    font-size: 14px;
                }

                &:hover {
                    background: rgba(255, 255, 255, 0.25);
                    border-color: rgba(255, 255, 255, 0.4);
                    transform: translateY(-1px);
                }

                &:active {
                    transform: translateY(0);
                }
            }
        }
    }

    .actions-container {
        display: flex;
        align-items: center;
        gap: 6px;
        flex: 1;
        justify-content: center;
        overflow-x: auto;
        overflow-y: hidden;
        padding: 2px 0;

        &::-webkit-scrollbar {
            height: 3px;
        }

        &::-webkit-scrollbar-track {
            background: rgba(255, 255, 255, 0.1);
            border-radius: 2px;
        }

        &::-webkit-scrollbar-thumb {
            background: rgba(255, 255, 255, 0.3);
            border-radius: 2px;

            &:hover {
                background: rgba(255, 255, 255, 0.5);
            }
        }

        .action-btn {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 4px;
            min-width: 65px;
            padding: 8px 8px;
            background: rgba(255, 255, 255, 0.12);
            border: 1px solid rgba(255, 255, 255, 0.25);
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
            position: relative;
            overflow: hidden;
            backdrop-filter: blur(10px);

            &::before {
                content: "";
                position: absolute;
                inset: 0;
                background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.05) 100%);
                opacity: 0;
                transition: opacity 0.25s ease;
            }

            &::after {
                content: "";
                position: absolute;
                inset: 0;
                background: radial-gradient(circle at center, rgba(255, 255, 255, 0.3) 0%, transparent 70%);
                opacity: 0;
                transform: scale(0);
                transition: all 0.4s ease;
            }

            &:hover {
                background: rgba(255, 255, 255, 0.2);
                border-color: rgba(255, 255, 255, 0.5);
                transform: translateY(-2px) scale(1.02);
                box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);

                &::before {
                    opacity: 1;
                }

                &::after {
                    opacity: 1;
                    transform: scale(1);
                }

                .material-icons {
                    color: #fff;
                    transform: scale(1.12);
                    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
                }

                span {
                    color: #fff;
                    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
                }
            }

            &:active {
                transform: translateY(-1px) scale(0.98);
            }

            .material-icons {
                font-size: 19px;
                color: rgba(255, 255, 255, 0.9);
                transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
            }

            span {
                font-size: 10px;
                font-weight: 600;
                color: rgba(255, 255, 255, 0.85);
                white-space: nowrap;
                transition: all 0.25s ease;
                letter-spacing: 0.2px;
            }
        }
    }

    .close-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        background: rgba(255, 255, 255, 0.15);
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.2s ease;
        flex-shrink: 0;

        .material-icons {
            font-size: 18px;
            color: #fff;
            transition: transform 0.2s ease;
        }

        &:hover {
            background: rgba(255, 255, 255, 0.25);
            border-color: rgba(255, 255, 255, 0.4);
            transform: rotate(90deg);
        }

        &:active {
            transform: rotate(90deg) scale(0.95);
        }
    }
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

// Responsive
@media (max-width: 1200px) {
    .bulk-actions-bar {
        .actions-container {
            .action-btn {
                min-width: 70px;
                padding: 8px 10px;

                .material-icons {
                    font-size: 18px;
                }

                span {
                    font-size: 10px;
                }
            }
        }
    }
}

@media (max-width: 768px) {
    .bulk-actions-bar {
        .bulk-actions-container {
            flex-direction: column;
            padding: 12px 16px;
            gap: 12px;
        }

        .selection-section {
            width: 100%;
            justify-content: space-between;
        }

        .actions-container {
            width: 100%;
            justify-content: flex-start;

            .action-btn {
                min-width: 60px;
                padding: 8px;

                .material-icons {
                    font-size: 16px;
                }

                span {
                    font-size: 9px;
                }
            }
        }

        .close-btn {
            position: absolute;
            top: 12px;
            right: 16px;
            width: 32px;
            height: 32px;

            .material-icons {
                font-size: 18px;
            }
        }
    }
}
</style>
